import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Hitechbanner = () => {
  const navigate = useNavigate();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  const styles = {
    container: {
      position: "relative",
      width: "100%",
      height: "500px",
      display: "flex",
      alignItems: "center", 
      justifyContent: "flex-start",  
      color: "white",
      overflow: "hidden",
      backgroundImage: "url('/image/hitechbanner.jpg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      padding: "50px",
    },
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.6)",  
      zIndex: 1,
    },
    content: {
      position: "relative",
      zIndex: 2,
      maxWidth: "700px",
      textAlign: "left",
      transform: animate ? "translateX(0)" : "translateX(-100px)",
      opacity: animate ? 1 : 0,
      transition: "all 1s ease-in-out",
    },
    heading: {
      fontSize: "40px",
      fontWeight: "bold",
      marginBottom: "20px",
      letterSpacing:"0px",
    },
    text: {
      fontSize: "18px",
      lineHeight: "1.6",
      marginBottom: "30px",
      textAlign:"justify",
    },
    button: {
      padding: "12px 25px",
      borderRadius: "25px",
      border: "none",
      fontSize: "16px",
      fontWeight: "bold",
      cursor: "pointer",
      backgroundColor: "#0078b7",
      color: "white",
      transition: "0.3s ease",
    },

     
    "@media (maxWidth: 768px)": {
      heading: {
        fontSize: "28px",
      },
      text: {
        fontSize: "16px",
      },
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.overlay}></div>

      <div style={styles.content}>
        <h1 style={styles.heading}>
       Powering Digital Futures.
        </h1>
        <p style={styles.text}>
         We co-create futuristic technologies and transformative experiences for a better world.
        </p>
        <button
          style={styles.button}
          onClick={() => navigate("/contactus")}
        >
          Contact us
        </button>
      </div>
    </div>
  );
};

export default Hitechbanner;
